<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <select v-model="selectedRunner" class="form-control">
              <option value="0">Все курьеры</option>
              <option v-for="runner in runners" :value="runner.id">{{ runner.name }}</option>
            </select>

            <div class="form-group m-t-10">
              <input v-model="showBackPack" type="checkbox" id="ch_11">
              <label for="ch_11" class="pointer">
                Показать выданые препараты
              </label>
            </div>

          </div>
          <div class="col-md-4">
            <DateSelectProps ref="selectedDate"
                             :customShortCutsDates="[
                               {title : 'Вчера', increment: 'minus', days: 1}
                             ]"
                             :disabled="true"
                             :useDisabledDates="false"
                             :selectedDate="selectedDate"
            />
          </div>
          <div class="col-md-4">
            <LoadingButton
              title="Показать"
              :loading="btnLoading"
              :onClick="showRecords"
              className="btn btn-info"/>
            <button @click="printTable" class="btn btn-success">Печать</button>
          </div>
        </div>
      </div>
    </div>

    <div id="printArea" v-if="!loading">
      <template v-for="(packs, runnerId) in backPacks">
        <div class="card" v-for="(pack, i) in packs">
          <div class="card-header">
            <h5>{{ sortedRunners[runnerId] && sortedRunners[runnerId].name || 'Без имени' }} ({{ pack.id }}) выдан:
              {{ printDate(pack.created_at, 'DD.MM.YYYY HH:mm') }} обнулен:
              {{
                printDate(resetsPacks[pack.id][Object.keys(resetsPacks[pack.id])[0]].created_at, 'DD.MM.YYYY HH:mm')
              }}</h5>
          </div>
          <div class="card-body">
            <table class="table table-sm table-hover">
              <thead>
              <tr>
                <th width="50"></th>
                <th>Препарат</th>
                <th v-if="showBackPack" width="100">Количество</th>
                <th width="100">Остаток</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="!showBackPack">
                <tr v-for="(item, i, ind) in resetsPacks[pack.id]" :key="i">
                  <td>{{ ind + 1 }}</td>
                  <td>{{ getItemTitle(item.drug_id, pack.id) }}</td>
                  <td>{{ resetsPacks[pack.id][item.drug_id].qty }}</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(item, i) in pack.items" :key="i">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.drug.title }}</td>
                  <td>{{ item.qty }}</td>
                  <td>{{ resetsPacks[pack.id][item.drug_id] && resetsPacks[pack.id][item.drug_id].qty || 0 }}</td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";
import DateSelectProps from "@/components/dateSelect/DateSelectProps";
import moment from 'moment';

import Vue from "vue";
import VueHtmlToPaper from '@/components/print/htmlToPrint.js';

Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '/assets/css/invoicePrint.css'
    // '../../../../../public/assets/css/invoicePrint1.css'
  ]
});


export default {
  data() {
    return {
      showBackPack: false,
      btnLoading: false,
      loading: false,
      runners: [],
      sortedRunners: {},
      selectedDate: moment().format('YYYY-MM-DD 00:00:00'),
      selectedRunner: 0,
      backPacks: {},
      resetsPacks: {},
    }
  },
  components: {
    LoadingButton,
    DateSelectProps
  },
  mounted() {
    this.getRunners()
  },
  methods: {
    printTable() {
      if (!Object.keys(this.resetsPacks).length) return;
      this.$htmlToPaper('printArea');
    },
    getItemTitle(drugId, packId) {
      let pack = null;
      Object.values(this.backPacks).forEach((packs) => {
        if (pack) return;
        pack = packs.find((p) => p.id === packId);
      });
      const drug = pack.items.find((i) => i.drug_id === drugId);
      return drug.drug.title;
    },
    async showRecords() {
      console.log('show');
      if (this.btnLoading) return;
      this.btnLoading = true;
      const {data} = await api.post('/runners/getBackPackHistory', {
        selectedRunner: this.selectedRunner,
        date: this.$refs.selectedDate.date
      });
      if (data.success) {
        this.resetsPacks = data.resetsPacks;
        this.backPacks = data.backPacks;
      } else {
        toastr["warning"](data.message || "Ошибка сервера");
      }
      this.btnLoading = false;
    },
    async getRunners() {
      this.loading = true;
      let {data} = await api.index('/runners/allRunners');
      if (data.success) {
        this.runners = data.runners;
        this.sortedRunners = data.runners.reduce((acc, r) => {
          acc[r.id] = {...r};
          return acc;
        }, {});
      } else {
        toastr["warning"](data.message || "Ошибка сервера");

      }
      this.loading = false;
    }
  }
}
</script>
